module.exports = __webpack_public_path__ + "static/media/fig_2.fbe315d2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/fig_2.jpg
// module id = 653
// module chunks = 0